export enum AtiraLinkPlanQRCount {
  PLAN_0 = '3',
  PLAN_1 = '6',
  PLAN_2 = '18',
}
